import React, {useContext, useEffect} from 'react'

import {FunnelPage, AppWrapper} from '@influxdata/clockface'
import {Honeybadger, HoneybadgerErrorBoundary} from '@honeybadger-io/react'

import HBContext from 'js/honeyBadgerContext'
import LogoWithCubo from 'js/components/LogoWithCubo'
import InviteSignUpForm from './InviteSignUpForm'

// Constants
import {GTM_INVITE_VIEWED} from 'js/constants'

interface Props {
  email: string
  orgName: string
  token: string
}

const InviteSignUp = ({email, orgName, token}: Props): JSX.Element => {
  const context = useContext<Honeybadger>(HBContext)

  useEffect(() => {
    // Google Tag Manager event for viewing an invitation
    window.dataLayer.push({
      event: GTM_INVITE_VIEWED,
    })
  }, [])

  return (
    <AppWrapper>
      <FunnelPage logo={<LogoWithCubo />}>
        <HoneybadgerErrorBoundary honeybadger={context}>
          <InviteSignUpForm email={email} orgName={orgName} token={token} />
        </HoneybadgerErrorBoundary>
      </FunnelPage>
    </AppWrapper>
  )
}

export default InviteSignUp
